import React from 'react'

import NavigationMenuItemUser from "../../menu-items/user/menu-item-user"
import NavigationMenuSection from "../../menu-items/section/section"
import ErrorBoundary from "../../../../core/error-boundary"
import {MenuSpaceSearch} from "../../components/search/menu-space-search";
import MenuSearch_NoResults from "../../../search/search-results/no-results";

type Props = {
    spaceSearch : MenuSpaceSearch
}

// const debug = "MainMenu_UsersSearchResults"
const debug = false

export default function MainMenu_UsersSearchResults(props:Props) {

    const searchResults = props.spaceSearch.searchResults

    return (
        <div className="">

            <ErrorBoundary>

            {_.map(searchResults, (departmentGroup, key)=>{
                return (
                    <NavigationMenuSection key          = {key}
                                           name         = {departmentGroup.label}
                                           collapsible  = {false}
                                           isOpen       = {true}>

                        {_.map(departmentGroup.items, (companyUser)=>{
                            return <NavigationMenuItemUser key          = {companyUser.id}
                                                           companyUser  = {companyUser}/>
                        })}

                    </NavigationMenuSection>
                )
            })
            }

            {_.isEmpty(searchResults) &&
                <MenuSearch_NoResults message="No users found in this space."/>
            }

            </ErrorBoundary>

        </div>
    );
}
